import {SiteLayout} from '@sainsburys-tech/luna-site-layout'
import Footer from './Footer/Footer'
import Header from './Header/header'

const Layout = (props: any) => {
  return (
      <>
        <SiteLayout>
          <Header/>
          {props.children}
          <Footer/>
        </SiteLayout>

      </>

  )
}

export default Layout